export default __webpack_public_path__ + "static/media/pdf.43e97512.svg";